<template>
  <div class="queue-status-tabs-container">
    <div :class="getTabClass('new')" @click="emitSwitch('new')">
      <svg
        width="24"
        height="28"
        viewBox="0 0 24 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.12332 27.966C8.18677 27.9714 8.2506 27.9622 8.31022 27.9391C8.36985 27.916 8.42381 27.8796 8.46824 27.8325C8.51267 27.7853 8.54646 27.7286 8.56721 27.6663C8.58796 27.6041 8.59515 27.5379 8.58827 27.4725C8.42937 25.9672 8.61426 24.4444 9.12807 23.0264C9.64189 21.6085 10.4703 20.335 11.5467 19.3083C11.673 19.1868 11.8391 19.1194 12.0116 19.1194C12.1841 19.1194 12.3502 19.1868 12.4766 19.3083C13.5568 20.3391 14.387 21.6185 14.9003 23.0427C15.4135 24.467 15.5953 25.9961 15.4309 27.5065C15.4247 27.5672 15.4305 27.6286 15.4481 27.6869C15.4657 27.7452 15.4947 27.7991 15.5333 27.8454C15.5718 27.8916 15.6192 27.9292 15.6723 27.9558C15.7255 27.9824 15.7834 27.9974 15.8424 28C26.3511 26.2982 24.2568 17.1172 22.7549 13.0203C22.6904 12.8361 22.5723 12.6771 22.4168 12.5651C22.2614 12.4531 22.0762 12.3937 21.8867 12.3949C21.7357 12.3948 21.587 12.4337 21.4541 12.508C21.3212 12.5822 21.2083 12.6896 21.1255 12.8203C20.1473 14.2681 18.8253 15.4314 17.2866 16.1983C18.377 5.98772 12.2709 1.78438 9.33302 0.120905C9.18715 0.0364655 9.02174 -0.0051638 8.85466 0.000511667C8.68757 0.00618714 8.52516 0.0589522 8.38497 0.153109C8.24477 0.247265 8.13212 0.379235 8.05918 0.534765C7.98623 0.690295 7.95577 0.863475 7.97108 1.0356C8.23441 5.29 4.39958 10.8718 2.16122 13.7605C0.577882 15.7466 -0.184919 18.2976 0.0380746 20.8611C0.647039 26.8088 6.25116 27.8 8.12332 27.966Z"
          fill="#A4A3A1"
        />
      </svg>
      {{ $t("tabs.new") }}
      <span
        class="amount color-red"
        v-if="counters.new"
      >({{ counters.new }})</span>
      <span class="amount color-grey" v-else>(0)</span>
    </div>
    <div :class="getTabClass('processing')" @click="emitSwitch('processing')">
      <svg
        width="27"
        height="28"
        viewBox="0 0 27 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.8687 10.4627C18.964 10.3369 19.0109 10.1789 19.0002 10.0193C18.9894 9.85972 18.9219 9.70996 18.8106 9.59909C18.6994 9.48822 18.5524 9.42414 18.3981 9.41929C18.2438 9.41444 18.0933 9.46916 17.9758 9.57284L6.81504 19.4144L0.921291 17.0519C0.664906 16.9502 0.442079 16.7743 0.279289 16.5452C0.116499 16.3161 0.020591 16.0434 0.00296048 15.7594C-0.0146701 15.4755 0.0467183 15.1923 0.179832 14.9434C0.312945 14.6946 0.512187 14.4906 0.75388 14.3557L25.2217 0.149534C25.414 0.0421711 25.6308 -0.00905859 25.849 0.00131294C26.0672 0.0116845 26.2786 0.0832681 26.4606 0.208423C26.6426 0.333579 26.7884 0.507609 26.8825 0.711939C26.9765 0.91627 27.0153 1.14323 26.9946 1.3686L24.8483 24.5576C24.8268 24.7954 24.752 25.0248 24.63 25.2274C24.5079 25.43 24.3419 25.6003 24.1452 25.7247C23.9484 25.8492 23.7264 25.9243 23.4967 25.9441C23.267 25.9639 23.0361 25.9279 22.8222 25.8389L15.6492 22.9603L11.1463 27.3339C10.9801 27.4948 10.772 27.6017 10.5478 27.6413C10.3236 27.681 10.0931 27.6517 9.88486 27.557C9.67658 27.4623 9.49964 27.3064 9.37594 27.1086C9.25224 26.9108 9.18719 26.6797 9.18885 26.444V23.0093L18.8687 10.4627Z"
          fill="#A4A3A1"
        />
      </svg>
      {{ $t("tabs.processing") }}
      <span class="amount">({{ counters.processing || 0 }})</span>
    </div>
    <div :class="getTabClass('done')" @click="emitSwitch('done')">
      <svg
        width="22"
        height="28"
        viewBox="0 0 22 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 22.4726V5.18598C0 3.81057 0.496675 2.4915 1.38076 1.51894C2.26485 0.546378 3.46393 3.60129e-08 4.71422 3.60129e-08H20.4283C20.6613 -5.22902e-05 20.8915 0.0569179 21.102 0.166783C21.3126 0.276649 21.4983 0.436658 21.6457 0.635222C21.7931 0.833786 21.8985 1.06593 21.9543 1.31485C22.0101 1.56376 22.0149 1.8232 21.9683 2.07439C21.886 2.47312 21.6813 2.82844 21.3886 3.08038C21.0958 3.33232 20.7331 3.46546 20.3615 3.45732H4.71422C4.48077 3.45713 4.25021 3.51417 4.03931 3.62429C3.8284 3.7344 3.64245 3.89483 3.49497 4.0939C3.34749 4.29298 3.24218 4.5257 3.1867 4.77516C3.13122 5.02462 3.12697 5.28454 3.17424 5.53603C3.25804 5.93431 3.46388 6.28873 3.75719 6.53978C4.05049 6.79082 4.41339 6.92318 4.78493 6.91463H20.4283C20.845 6.91463 21.2447 7.09676 21.5394 7.42095C21.8341 7.74513 21.9997 8.18482 21.9997 8.64329V25.9299C21.9997 26.3883 21.8341 26.828 21.5394 27.1522C21.2447 27.4764 20.845 27.6585 20.4283 27.6585H4.71422C3.46393 27.6585 2.26485 27.1122 1.38076 26.1396C0.496675 25.167 0 23.848 0 22.4726Z"
          fill="#A4A3A1"
        />
      </svg>
      {{ $t("tabs.done") }}
      <span
        class="amount color-red"
        v-if="counters.done"
      >({{ counters.done }})</span>
      <span class="amount color-grey" v-else>(0)</span>
    </div>
  </div>
</template>

<style scoped>
.tab-wide {
  text-align: center;
  width: 42vw;
  display: block !important;
  position: relative;
}

.tab {
  line-height: 0.8;
  border-radius: 5vh;
  box-shadow: 0px 1px 7px #dadada;
  background: #ededed;
  padding: 1.4vh 0 0.8vh;
  font-size: 1.6vh;
  display: flex;
  transition: 0.3s;
  position: relative;
}

.active {
  background: black;
  color: white;
  cursor: pointer;
}

.color-red {
  color: #e2223b !important;
}

.amount {
  background: #e2223b;
  color: #ededed;
  margin: 0;
  position: absolute;
  top: -1vh;
  right: -1vh;
  font-size: 3.6vw;
  border-radius: 5vh;
  text-align: center;
  line-height: 1.5;
  padding: 0 1.5vw;
  font-weight: 600;
  letter-spacing: 0;
  animation: amount 0.5s;
}

.amount.grey {
  background: #616161;
  padding: 0 2.2vw;
}

.queue-status-tabs-container {
  display: flex;
  justify-content: space-between;
  z-index: 1;
  width: 100%;
  padding: 0;
  margin: 0 auto;
  padding-bottom: 2.2vh;
  background: linear-gradient(
    0deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.21) 100%
  );
  backdrop-filter: blur(3px);
  text-align: center;
}

@media (min-width: 300px) and (max-width: 500px) {
  .queue-status-tabs-container {
    padding: 0;
    bottom: 0;
    position: fixed;
    background: #1d1d1b;
  }

  .tab {
    box-shadow: none;
    color: #a4a3a1;
    flex-basis: 33%;
    display: block;
  }

  .tab,
  .tab.active {
    background: transparent;
    display: block;
  }

  .tab.active {
    color: #ededed;
  }

  .tab.active path {
    fill: #ededed;
  }

  .tab svg {
    display: block;
    margin: 0 auto 1vh;
  }
}

.empty-amount {
  color: #a4a3a1 !important;
}

@media (min-width: 768px) {
  div.queue-status-tabs-container {
    position: fixed;
    left: 0;
    bottom: 0;
    background: rgba(29, 29, 27, 0.9);
    backdrop-filter: blur(7px);
    height: 5.694vw;
    padding: 0 16.25vw;
  }
  .tab.tab-wide:nth-child(3) {
    display: none;
  }
  div.tab {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: none;
    box-shadow: none;
    color: white;
  }
  .tab.tab-wide:nth-child(3) {
    display: none !important;
  }

  div.tab svg {
    margin-bottom: 0.347vw;
  }
  .tab path {
    fill: #ededed;
  }
  .tab-wide {
    width: 38vh;
    font-size: 1.7777vh;
    margin-top: 2.222vh;
    background: #1d1d1b;
    color: #ededed;
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.694vw;
    line-height: 0.833vw;
    border: 0;
    background: none;
    box-shadow: none;
    color: #ededed;
  }
  span.amount {
    position: unset;
    background: none;
    font-size: 0.694vw;
    line-height: 0.833vw;
    color: #e2223b !important;
  }
  .tab.active span.amount {
    color: #ededed;
  }
}

@media screen and (max-width: 450px) {
  .amount {
    position: initial;
    font-size: 1.6vh;
    display: block;
    width: fit-content;
    margin: 0 auto;
    background: transparent;
  }
  div.tab svg {
    fill: white !important;
  }
}
</style>

<script>
export default {
  props: {
    currentTab: String,
    is_preorder: {
      type: Boolean,
      default: false,
    },
    counters: Object,
  },
  methods: {
    emitSwitch(nt) {
      this.$emit("switch", nt);
    },
    getTabClass(tab) {
      return {
        tab: true,
        active: this.currentTab === tab || this.isDesktop,
        "tab-wide": this.is_preorder,
      };
    },
  },
  computed: {
    // counters() {
    //   return this.$store.getters["queue/tabCounters"];
    // }
  },
};
</script>
